/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Make displayed Bold subscription prices change on variant selection
jQuery('.product-single__swatch').click(function(evt) {
	setTimeout(function() {
		if ($('.bold-ro__initial-discount-percent').length < 1) { return; }
		var perc = $('.bold-ro__initial-discount-percent').text();
		perc = parseFloat(perc) / 100.0;
		var oldPrice = $('.product-single__price-number .money').text();
		oldPrice = parseFloat(oldPrice.replace('$', ''));
		var newPrice = oldPrice - (oldPrice * perc);
		newPrice = '$' + newPrice.toFixed(2);
		$('.bold-ro__initial-discount-price').text(newPrice);
	}, 700);
});

if (jQuery('.section--cart').length > 0) {
	setTimeout(function() {
		jQuery('.cart__row').each(function() {
			var boldDesc = $(this).find('.bold_recurring_desc');
			if (boldDesc.text() != '') {
				var singlePrice = boldDesc.find('.ro-price').text();
				var singlePriceNum = parseFloat(singlePrice.replace('$', ''));
				$(this).find('.single-cart-item__price').text(singlePrice);
				var quantity = $(this).find('.js-qty__num').val();
				var totalPrice = singlePriceNum * quantity;
				$(this).find('.total-cart-item__price').text('$' + totalPrice.toFixed(2));
			}
		});
	}, 700);
}

var utils = {
initializeTabs: function(){
    $('ul.tabs > li > a').attr('data-no-instant', true);
    $('body').on('click', 'ul.tabs > li > a', function(e) {
      e.preventDefault();
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="#") {
        $('ul.tabs > li > a.active').removeClass('active');
        $(this).addClass('active');
        $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
      }
    });
  }
}
utils.initializeTabs();